import React from "react";
import moment from "moment";
export default function Date({date, format="DD/MMM/YY HH:mm"}){
	return <>
		{moment(date).format(format)}
	</>;
}